export default "/mqEditor/./assets/mq_plusminussign.png";